import { render, staticRenderFns } from "./SelfDivSetting.vue?vue&type=template&id=487776af&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./SelfDivSetting.vue?vue&type=script&lang=js"
export * from "./SelfDivSetting.vue?vue&type=script&lang=js"
import style0 from "./SelfDivSetting.vue?vue&type=style&index=0&id=487776af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487776af",
  null
  
)

export default component.exports